import * as Yup from 'yup';

export const ClearerReassignSchema = Yup.object().shape({
  clearer: Yup.string().min(1).required('Clearer is required'),
});

export type ClearerReassignDataType = Yup.InferType<
  typeof ClearerReassignSchema
>;

type InitialValues = {
  clearer: string;
};

export const ClearerReassignInitialValues: InitialValues = {
  clearer: '',
};

export interface IClearerReassignResponse {}

export interface IClearerReassignRequest {
  // clearer: string;
  clearerId: string;
  cargoId: string;
}
